import { connect } from 'react-jplaylist';
import DemoVideoView from '../../../common/components/demoVideos/DemoVideoView';
import {
    TRO_PLAYLIST,
    TRO_OPTIONS,
} from '../../../common/components/demoVideos/demoVideoConstants';

const { READING_BOOKS, ANSWERING_QUESTIONS } = TRO_PLAYLIST;

const jPlaylistOptions = {
    loopOnPrevious: false,
    loop: 'off',
    playlist: [
        {
            artist: '',
            title: READING_BOOKS.TITLE,
            demoVideoId: READING_BOOKS.ID,
            sources: {
                m4v: `${TRO_OPTIONS.trcPracticeVideoBucketCDN}/${READING_BOOKS.FILE_NAME}`,
            },
        },
        {
            artist: '',
            title: ANSWERING_QUESTIONS.TITLE,
            demoVideoId: ANSWERING_QUESTIONS.ID,
            sources: {
                m4v: `${TRO_OPTIONS.trcPracticeVideoBucketCDN}/${ANSWERING_QUESTIONS.FILE_NAME}`,
            },
        },
    ],
};

export default connect(DemoVideoView, TRO_OPTIONS, jPlaylistOptions);
